import common from '@/modules/common'
import BarChart from '@/components/chart/Bar.js'
import LineChart from '@/components/chart/Line.js'
import HorizontalBarChart from '@/components/chart/HorizontalBar.js'
import RadarChart from '@/components/chart/Radar.js'

export default {
  components: {BarChart, HorizontalBarChart, RadarChart, LineChart},
  mixins: [common.mixins],
  data () {
    return {
      tabActive: true,
      pdfLoading: false,
      commentVisible: true,
      lineVisible: true,
      radarVisible: true,
      graphVisible: true,
      timesVisible: true,
      pdfPercentage: 0,
      examInfo: {
        exam_seq: 0,
        class_seq: 0,
        class_user_seq: 0,
        exam_paper_type: '',
        exam_paper_type_name: '',
        exam_title: '',
        cate_path: '',
        class_name: '',
        class_user_name: '',
        curriculum_yn: '',
        curriculum_name: '',
        times: '',
        exam_comment: '',
        exam_times_comment: '',
        entry_cnt: '',
        exam_rank: '',
        open_dt: '',
        picture_path: '',
        stat: '',
        phone: '',
        exam_score: 0,
        subject: '',
        book_name: '',
        quiz_score: 0,
        close_yn: ''
      },
      // tableProps: {showSummary: true, sumText: '총점', sortable: false},
      tableProps: {sortable: false},
      tableProps2: {showSummary: true, sumText: '총점', sortable: false, summaryMethod: this.getSummaries},
      groupData: [],
      groupColumns: [
        {label: '영역', prop: 'cate_code_name', align: 'center', class: 'font-bold'},
        {label: '배점', prop: 'group_score_sum', align: 'center', class: 'number'},
        {label: '내점수', prop: 'user_group_score', align: 'center', class: 'number'},
        {label: '전체평균', prop: 'group_score_avg', align: 'center', class: 'number'},
        {label: '상위10%', prop: 'group_top_10', align: 'center', class: 'number'},
        {label: '상위30%', prop: 'group_top_30', align: 'center', class: 'number'}
      ],
      timesTableProps: {showSummary: true, sumText: '총점', sortable: false, summaryMethod: this.getSummaryTimes},
      groupTimesData: [],
      groupTimesColumns: [
        {label: '영역', prop: 'cate_code_name', align: 'center'},
        {label: '', prop: 'm0_group_score', align: 'center', class: 'number', alies: 'm0', formatter: this.timesFormatter0},
        {label: '', prop: 'm1_group_score', align: 'center', class: 'number', alies: 'm1', formatter: this.timesFormatter1},
        {label: '', prop: 'm2_group_score', align: 'center', class: 'number', alies: 'm2', formatter: this.timesFormatter2},
        {label: '', prop: 'm3_group_score', align: 'center', class: 'number', alies: 'm3', formatter: this.timesFormatter3}
      ],
      groupStackColumns: [
        {label: '영역', prop: 'cate_code_name', align: 'center'},
        {label: '배점', prop: 'group_score_sum', align: 'center', class: 'number'},
        {label: '내점수', prop: 'user_group_score', align: 'center', class: 'number'},
        {label: '나의성취도', prop: 'user_group_score_100', align: 'center', formatter: this.columnFormatterRate, class: 'number'},
        {label: '전체평균', prop: 'group_correct_avg_100', align: 'center', formatter: this.columnFormatterRate, class: 'number'}
      ],
      groupWrongColumns: [
        {label: 'No', align: 'center', type: 'index', width: 40},
        {label: '영역', prop: 'group_name', align: 'center', width: 50},
        {label: '내용', prop: 'cate_path', align: 'left', width: 200}
      ],
      quizWrongData: [],
      quizWrongTotalData: [],
      quizTableProps: {showHeader: false, sortable: false},
      quizData: [],
      barChartData: [],
      radarChartData: [],
      radarTotalChartData: [],
      lineChartData: [],
      barChartHeight: 339,
      lineChartHeight: 165,
      radarChartHeight: 178,
      timesLineChartHeight: 165,
      timesRadarChartHeight: 178,
      quizSplitCount: 0,
      examTotalTimesSplitCount: 0,
      examTotalTimesData: [],
      param: {},
      itemCount: 20,
      totalData: [],
      totalColumns: [
        {label: '회차', prop: 'times_name', align: 'center', width: 80},
        {label: '시험일', prop: 'open_date', align: 'center', width: 100},
        {label: '시험명', prop: 'title', align: 'left', width: 200},
        {label: '총점', prop: 'exam_score', align: 'center', width: 100, class: 'number'},
        {label: '맞은갯수', prop: 'correct_cnt', align: 'center', width: 100, class: 'number'},
        {label: '전체석차', prop: 'exam_rank', align: 'center', width: 100, class: 'number'}
      ],
      categoryData: [],
      tableGroupProps: {showSummary: true, sumText: '합계', sortable: false, summaryMethod: this.getSummariesGroup},
      totalGroupData: {},
      totalGroupColumns: [
        {label: '회차', prop: 'times_name', align: 'center', width: 80},
        {label: '시험일', prop: 'open_date', align: 'center', width: 100},
        {label: '시험명', prop: 'title', align: 'left', width: 200},
        {label: '총점', prop: 'group_score', align: 'center', width: 100, class: 'number'},
        {label: '맞은갯수', prop: 'group_correct_cnt', align: 'center', width: 100, class: 'number'},
        {label: '전체석차', prop: 'exam_rank', align: 'center', width: 100, class: 'number'}
      ],
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {left: 10, right: 10, top: 20, bottom: 10}
        },
        cornerRadius: 6,
        legend: {display: false},
        categoryPercentage: 1.0,
        barPercentage: 0.5,
        scales: {
          yAxes: [
            {
              ticks: {min: 0},
              maxBarThickness: 12,
              categoryPercentage: 0.9,
              barPercentage: 0.8
            }
          ],
          xAxes: [
            {
              gridLines: {display: false},
              maxBarThickness: 12,
              categoryPercentage: 0.9,
              barPercentage: 0.8
            }
          ]
        }
      },
      radarChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {left: 10, right: 10, top: 20, bottom: 10}
        },
        legend: {display: false}
      },
      lineChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {left: 10, right: 10, top: 20, bottom: 10}
        },
        legend: {display: false},
        scales: {
          yAxes: [
            {ticks: {min: 0, padding: 20}, stacked: false, beginAtZero: true}
          ],
          xAxes: [
            {gridLines: {display: false}}
          ]
        },
        onClick: this.onClickLineChart,
        tooltips: {
          mode: 'index',
          intersect: false
        }
      },
      lineChartOptions2: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {left: 10, right: 10, top: 20, bottom: 10}
        },
        legend: {display: false},
        scales: {
          yAxes: [
            {ticks: {min: 0, padding: 20}, stacked: false, beginAtZero: true}
          ],
          xAxes: [
            {gridLines: {display: false}}
          ]
        },
        onClick: this.onClickLineChart,
        tooltips: {
          mode: 'index',
          callbacks: {
            // Use the footer callback to display the sum of the items showing in the tooltip
            footer: (tooltipItems, data) => {
              // console.log(data)
              let sum = 0
              tooltipItems.forEach(tooltipItem => {
                sum += data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              })
              return 'Sum: ' + sum
            }
          },
          footerFontStyle: 'normal'
        }
      }
    }
  },
  computed: {
    radarChartStyles () {
      return {
        height: `${this.radarChartHeight}px`,
        position: 'relative'
      }
    },
    lineChartStyles () {
      return {
        height: `${this.lineChartHeight}px`,
        position: 'relative'
      }
    },
    timesRadarChartStyles () {
      return {
        height: `${this.timesRadarChartHeight}px`,
        position: 'relative'
      }
    },
    timesLineChartStyles () {
      return {
        height: `${this.timesLineChartHeight}px`,
        position: 'relative'
      }
    },
    barChartStyles () {
      return {
        height: `${this.barChartHeight}px`,
        position: 'relative'
      }
    }
  },
  created () {
    if (this.$route.params) {
      this.param = {
        exam_seq: this.getToNumber(this.$route.params.exam_seq),
        class_seq: this.getToNumber(this.$route.params.class_seq),
        class_user_seq: this.getToNumber(this.$route.params.class_user_seq)
      }
      this.loadInfo()
    }
  },
  methods: {
    loadExamGrade () {
      // 개인 성적표
      common.axios.post('/grade/personal/', this.param)
        .then(response => {
          const result = response.data
          // console.log('loadExamGrade : ', result)
          const examGroupData = result.exam_group.slice()
          const examGroupDataSum = {
            cate_code_name: '총점',
            group_score_sum: 0,
            user_group_score: 0,
            group_score_avg: 0,
            group_top_10: 0,
            group_top_30: 0,
            group_score_sum_100: 0,
            user_group_score_100: 0,
            group_score_avg_100: 0,
            group_top_10_100: 0,
            group_top_30_100: 0
          }
          let examGroupCount = 0
          // 성적 그룹 합계를 구한다.
          examGroupData.forEach(x => {
            Object.keys(examGroupDataSum).forEach(key => {
              if (key !== 'cate_code_name') {
                examGroupDataSum[key] += x[key]
              }
            })
            // 실제 배점이 있는 그룹만 계산한다.
            if (x.group_score_sum > 0) {
              examGroupCount++
            }
          })
          // 총점 평균
          Object.keys(examGroupDataSum).forEach(key => {
            if (key !== 'cate_code_name') {
              examGroupDataSum[key] = parseInt(examGroupDataSum[key].toFixed(0))
            }
            if (key !== 'group_score_sum_100' && key.indexOf('_100') !== -1) {
              examGroupDataSum[key] = parseInt((examGroupDataSum[key] / examGroupCount).toFixed(0))
            }
          })
          examGroupData.push(examGroupDataSum)
          this.groupData = examGroupData
          this.quizData = result.exam_quiz
          this.quizSplitCount = this.getQuizRows()
          this.quizWrongData = result.exam_wrong
          if (this.quizWrongData.length < 10) {
            for (let i = this.quizWrongData.length; i < 10; i++) {
              this.quizWrongData.push({group_name: '', cate_path: ''})
            }
          }
          this.barChartData = this.getBarChartData(result.exam_group)
          this.radarChartData = this.getRadarChartData(result.exam_group)
        })
    },
    getQuizRows () {
      let quizRows = 1
      if (this.quizData.length > this.itemCount) {
        quizRows = parseInt(this.quizData.length / this.itemCount, 10)
        if (this.quizData.length % this.itemCount > 0) {
          quizRows++
        }
      }
      return quizRows
    },
    getExamTotalTimesRows () {
      let examTotalTimesRow = 1
      if (this.examTotalTimesData.length > this.examTotalTimesCount) {
        examTotalTimesRow = parseInt(this.examTotalTimesData.length / this.examTotalTimesCount, 10)
        if (this.examTotalTimesData.length % this.examTotalTimesCount > 0) {
          examTotalTimesRow++
        }
      }
      return examTotalTimesRow
    },
    loadExamGradeTimes () {
      // 회차 성적표
      common.axios.post('/grade/times/', this.param)
        .then(response => {
          const result = response.data
          if (result.exam_total) {
            const obj = result.exam_total[0]
            this.groupTimesColumns.map(x => {
              if (x.prop !== 'cate_code_name') {
                Object.keys(obj).forEach(key => {
                  if (x.prop === key) {
                    x.label = obj[x.alies + '_title']
                  }
                })
              }
            })
            this.$nextTick(() => {
              this.groupTimesData = result.exam_total
            })
          }
        })
    },
    loadExamGradeTotal () {
      // 종합 성적표
      common.axios.post('/grade/total/', this.param)
        .then(response => {
          const result = response.data
          // console.log('loadExamGradeTotal : ', result)
          this.lineChartData = this.getLineChartData(result.exam_total)
          this.quizWrongTotalData = result.exam_total_wrong
          if (this.quizWrongTotalData.length < 10) {
            for (let i = this.quizWrongTotalData.length; i < 10; i++) {
              this.quizWrongTotalData.push({group_name: '', cate_path: ''})
            }
          }
          this.radarTotalChartData = this.getRadarChartData(result.exam_total_group_times)
        })
    },
    loadExamGradeTotalTimes () {
      // 종합 성적표 (누적 회차별 성적)
      common.axios.post('/grade/total/times', this.param)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          if (Object.keys(result).length === 0) {
            return
          }
          this.examTotalTimesData = result.exam_total_grade // 누적 회차별 성적
          this.examTotalTimesSplitCount = this.getExamTotalTimesRows()
          this.lineChartData = this.getLineChartData(result.exam_total) // 누적 성적
          this.radarTotalChartData = this.getRadarChartData(result.exam_total_group_times) // 누적 스파이더 차트
          this.quizWrongTotalData = result.exam_total_wrong // 누적 취약 유형
          if (this.quizWrongTotalData.length < 10) {
            for (let i = this.quizWrongTotalData.length; i < 10; i++) {
              this.quizWrongTotalData.push({group_name: '', cate_path: ''})
            }
          }
        })
    },
    getSummariesGrade (param) {
      return this.getSummaryGrade(param)
    },
    getSummaries (param) {
      return this.getSummary(param, [3, 4], '%')
    },
    getSummariesGroup (param) {
      return this.getSummary(param, [3, 4, 5], '')
    },
    getSummariesTimes (param) {
      return this.getSummaryTimes(param)
    },
    getSummary (param, avg, subFix) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '총점'
          return
        }
        if (!column.label) {
          sums[index] = ''
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = ''
        }
      })
      avg.map(i => {
        sums[i] = parseFloat((sums[i] / data.length).toFixed(1)) + subFix
      })
      return sums
    },
    getSummaryTimes (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '총점'
          return
        }
        if (!column.label) {
          sums[index] = ''
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = ''
        }
        const valuesSum = data.map(item => Number(item[column.property + '_sum']))
        if (!valuesSum.every(value => isNaN(value))) {
          sums[index] += ' / ' + valuesSum.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] += ''
        }
      })
      return sums
    },
    getSummaryGrade (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '총점'
          return
        }
        if (!column.label) {
          sums[index] = ''
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] = ''
        }
        const valuesSum = data.map(item => Number(item[column.property + '_100']))
        if (!valuesSum.every(value => isNaN(value))) {
          sums[index] += ' \n ' + valuesSum.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else {
          sums[index] += ''
        }
      })
      return sums
    },
    getSolutionName (value) {
      return value === 'Y' ? 'O' : 'X'
    },
    getSolutionClassName (value) {
      return 'font-bold ' + (value === 'Y' ? 'font-green' : 'font-red')
    },
    getSolutionRateClassName (value) {
      return 'number font-bold ' + (value === 'Y' ? '' : 'font-red')
    },
    getBarChartData (value) {
      const labels = []
      const datasets1 = []
      const datasets2 = []
      value.map(x => {
        labels.push(x.cate_code_name)
        datasets1.push(x.user_group_score)
        datasets2.push(x.group_score_avg)
      })
      const datasets = [
        {
          label: '내점수',
          backgroundColor: '#00aec0',
          data: datasets1
        },
        {
          label: '평균점수',
          backgroundColor: '#292955',
          data: datasets2
        }
      ]
      return {labels: labels, datasets: datasets}
    },
    getCorrectChartData (value) {
      const labels = []
      const datasets1 = []
      const datasets2 = []
      value.map(x => {
        labels.push(x.cate_code_name)
        datasets1.push(x.user_group_correct_cnt)
        datasets2.push(x.group_correct_avg)
      })
      const datasets = [
        {
          label: '내정답수',
          backgroundColor: '#00aec0',
          data: datasets1
        },
        {
          label: '평균정답수',
          backgroundColor: '#292955',
          data: datasets2
        }
      ]
      return {labels: labels, datasets: datasets}
    },
    getRadarChartData (value) {
      const labels = []
      const datasets1 = []
      const datasets2 = []
      value.map(x => {
        labels.push(x.cate_code_name)
        datasets1.push(x.user_group_score_100)
        datasets2.push(x.group_correct_avg_100)
      })

      const datasets = [
        {
          label: '내점수',
          // backgroundColor: 'transparent',
          borderColor: '#00aec0',
          // fill: false,
          radius: 4,
          pointRadius: 4,
          pointBorderWidth: 2,
          pointBackgroundColor: '#00aec0',
          pointBorderColor: '#00aec0',
          pointHoverRadius: 5,
          data: datasets1
        },
        {
          label: '평균점수',
          // backgroundColor: 'transparent',
          borderColor: '#292955',
          // fill: false,
          radius: 4,
          pointRadius: 4,
          pointBorderWidth: 2,
          pointBackgroundColor: '#292955',
          pointBorderColor: '#292955',
          pointHoverRadius: 5,
          data: datasets2
        }
      ]
      return {labels: labels, datasets: datasets}
    },
    getLineChartData (value) {
      const labels = []
      const datasets1 = []
      const datasets2 = []
      // console.log('value : ', value)
      value.map(x => {
        labels.push(x.times_name)
        datasets1.push(x.exam_score_100)
        datasets2.push(x.avg_score_100)
      })
      const datasets = [
        {
          label: '내점수',
          // backgroundColor: '#00aec0',
          borderColor: '#00aec0',
          fill: false,
          radius: 3,
          pointRadius: 3,
          pointBorderWidth: 1,
          pointBackgroundColor: '#00aec0',
          pointBorderColor: '#00aec0',
          pointHoverRadius: 4,
          data: datasets1
        },
        {
          label: '평균점수',
          // backgroundColor: '#292955',
          borderColor: '#292955',
          fill: false,
          radius: 3,
          pointRadius: 3,
          pointBorderWidth: 1,
          pointBackgroundColor: '#292955',
          pointBorderColor: '#292955',
          pointHoverRadius: 4,
          data: datasets2
        }
      ]
      return {labels: labels, datasets: datasets, values: value}
    },
    timesFormatter0 (row) {
      return this.timesFormatter(row, 0)
    },
    timesFormatter1 (row) {
      return this.timesFormatter(row, 1)
    },
    timesFormatter2 (row) {
      return this.timesFormatter(row, 2)
    },
    timesFormatter3 (row) {
      return this.timesFormatter(row, 3)
    },
    timesFormatter (row, index) {
      return row['m' + index + '_times_yn'] === 'Y' ? `${row['m' + index + '_group_score']} / ${row['m' + index + '_group_score_sum']}` : ''
    },
    onClickLineChart (evt, legendItem) {
      if (legendItem && legendItem.length > 0) {
        if (typeof this.handleLineChartOnClick === 'function' || false) {
          // this.handleLineChartOnClick.call(null, legendItem[0]._index)
        }
      }
    },
    handlerTabClick () {
      let tableRef = ''
      if (this.activeTabName === 'tab-personal') {
        tableRef = 'tabGroupTable'
      } else if (this.activeTabName === 'tab-total') {
        // tableRef = this.timesVisible ? 'tabGroupTimesTable' : 'tabGroupTotalTable'
        tableRef = ''
      }
      this.$nextTick(() => {
        if (tableRef !== '') {
          if (tableRef === 'tabGroupTable') {
            this.$refs[tableRef].$refs.elTable.doLayout()
          } else {
            if (this.$refs[tableRef].$refs.stoneDataTable) {
              this.$refs[tableRef].$refs.stoneDataTable.$refs.elTable.doLayout()
            }
          }
        }
      })
    },
    customTooltips (tooltip, ref) {
      // Tooltip Element
      let tooltipEl = document.getElementById('chartjs-tooltip')

      if (!tooltipEl) {
        tooltipEl = document.createElement('div')
        tooltipEl.id = 'chartjs-tooltip'
        tooltipEl.innerHTML = '<table></table>'
        // this._chart.canvas.parentNode.appendChild(tooltipEl)
        this.$refs[ref].$refs.canvas.parentNode.appendChild(tooltipEl)
      }
      // Hide if no tooltip
      if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0
        return
      }

      // Set caret Position
      tooltipEl.classList.remove('above', 'below', 'no-transform')
      if (tooltip.yAlign) {
        tooltipEl.classList.add(tooltip.yAlign)
      } else {
        tooltipEl.classList.add('no-transform')
      }

      // Set Text
      if (tooltip.body) {
        const titleLines = tooltip.title || []
        const bodyLines = tooltip.body.map(bodyItem => bodyItem.lines)

        let innerHtml = '<thead>'

        titleLines.forEach(title => {
          innerHtml += '<tr><th>' + title + '</th></tr>'
        })
        innerHtml += '</thead><tbody>'

        bodyLines.forEach((body, i) => {
          const colors = tooltip.labelColors[i]
          let style = 'background:' + colors.backgroundColor
          style += '; border-color:' + colors.borderColor
          style += '; border-width: 2px'
          const span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>'
          innerHtml += '<tr><td>' + span + body + '</td></tr>'
        })
        innerHtml += '</tbody>'

        const tableRoot = tooltipEl.querySelector('table')
        tableRoot.innerHTML = innerHtml
      }

      const positionY = this.$refs[ref].$refs.canvas.offsetTop
      const positionX = this.$refs[ref].$refs.canvas.offsetLeft

      // Display, position, and set styles for font
      tooltipEl.style.opacity = 1
      tooltipEl.style.left = positionX + tooltip.caretX + 'px'
      tooltipEl.style.top = positionY + tooltip.caretY + 'px'
      tooltipEl.style.fontFamily = tooltip._bodyFontFamily
      tooltipEl.style.fontSize = tooltip.bodyFontSize + 'px'
      tooltipEl.style.fontStyle = tooltip._bodyFontStyle
      tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px'
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/grade.js